import axios from 'axios';

export const login = async (username, password, rememberMe) => {
    const data = {
        user: {
            email: username,
            password: password,
            rememberMe: rememberMe
        }
    };
    const url = `/api/v1/auth/sign_in`;
    await axios.post(url, data);
};

export const logout = async () => {
    const url = `/api/v1/auth/sign_out`;
    await axios.delete(url);
};

export const resetPasswordRequest = async (email) => {
    const data = {
        user: {
            email: email
        }
    };
    const url = `/api/v1/auth/password`;
    await axios.post(url, data);
};

export const changePasswordRequest = async (token, password, passwordConfirmation) => {
    const data = {
        user: {
            resetPasswordToken: token,
            password: password,
            passwordConfirmation: passwordConfirmation
        }
    };
    const url = `/api/v1/auth/password`;
    await axios.patch(url, data);
};

export const unlockAccount = async (token) => {
    const url = `/api/v1/auth/unlock?unlock_token=${token}`;
    await axios.get(url);
};